import { MicroservicoMonitoramento } from './microservico-monitoraemtno.model';
import { AplicacaoMonitoramento } from './aplicacao-monitoramento.model';
import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { InternetMonitoramento } from './internet-monitoramento.model';

export class PrismaMonitoramento extends AplicacaoMonitoramento {

  iris: MicroservicoMonitoramento;

  public static getAtivos(monitoramento: PrismaMonitoramento): AtivoMonitoramentoDetalhado[] {
    return [
      InternetMonitoramento.getAtivo(monitoramento.internet),
      MicroservicoMonitoramento.getAtivo('Iris', monitoramento.iris)
    ];
  }
}
